<template>
	<div>
		<div
			class="Sticky-button hidden-below-grid-breakpoint"
			v-if="!opened"
			v-on:click="toggleChatWindow"
			:title='t("activerecord.models.moderator_chat.one")'
		>
			<span class="senaryon-icon senaryon-icon-chat"></span>
			<!-- @vue-expect-error -->
			<div v-if="unreadCount > 0" class="Sticky-button__floating-overlay">
				{{ unreadCount }}
			</div>
		</div>
		<div
			class="moderatorChat-maximized moderatorChat-actorView"
			v-click-outside="toggleChatWindow"
			v-if="opened"
		>
			<div class="moderatorChatHeader">
				<div class="moderatorChatHeader-title">
					{{ t("moderator_chats.title_actor") }}
				</div>
				<div
					class="moderatorChatHeader-action-close pull-right"
					v-on:click="toggleChatWindow"
				>
					<span class="senaryon-icon senaryon-icon-close"></span>
				</div>
			</div>
			<div class="moderatorChatBody">
				<moderator-conversation
					:chat="chat"
					@replied="reply"
				></moderator-conversation>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
// Other components
import { i18n } from "../utils";
import ModeratorConversation from "./moderator_conversation.vue";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		srvChat: Object,
		srvUnreadMessagesCount: Number,
	},
	data: function () {
		return {
			chat: this.srvChat,
			sending: false,
			opened: false,
			unreadCount: this.srvUnreadMessagesCount,
		};
	},
	components: {
		"moderator-conversation": ModeratorConversation,
	},
	computed: {},
	mounted() {
		// We are not using the `selectRecipientIds` for Actors
		pp.vue.bus.$on("vue-hook:open-moderator-chat", (selectRecipientIds) => {
			this.toggleChatWindow(null);
		});
		pp.vue.bus.$on("moderator_chat-CREATE", (chat) => {
			this.chat = chat;
			this.opened = true;
		});

		pp.vue.bus.$on("moderator_chat_message-CREATE", (msg) => {
			// @ts-expect-error
			this.chat.messages.push(msg);
			this.opened = true;
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("vue-hook:open-moderator-chat");
		pp.vue.bus.$off("moderator_chat_message-CREATE");
		pp.vue.bus.$off("moderator_chat-CREATE");
	},
	methods: {
		toggleChatWindow(event) {
			if (event) {
				event.stopPropagation();
			}
			if (!this.opened) {
				$.post("/moderator_chats/opened_chat.json", (res) => {});
				// @ts-expect-error
				this.unreadCount = 0;
			}
			this.opened = !this.opened;
			$(document).trigger("page:change", [{ noVue: true }]); // trigger navbar collapse in case this was triggered from there
		},
		sendMessage(e, obj) {
			this.sending = true;
			$.post(
				"/moderator_chat_messages.json",
				{
					message_content: obj.messageContent,
				},
				(res) => {
					if (res.new_moderator_chat) {
						this.chat = res.new_moderator_chat;
					} else {
						// @ts-expect-error
						this.chat.messages.push(res.message);
					}
					this.sending = false;
				},
			);
		},
		reply(obj) {
			this.sendMessage(null, obj);
		},
	},
};
</script>
